import { antMenuApi } from "@/core/services/apis/antMenu";
import { STATUS_CODE } from "@/core/config/constant";
import { normalizeHierarchyTreeFromRoot } from "@/core/services/tenantHierarchy.service";

const { SUCCESS } = STATUS_CODE;

function resolveAntMenuPayload(responseData) {
    const { tree, hierarchy_menu_open } = responseData || {};
    const normalizedTree = normalizeHierarchyTreeFromRoot(tree);
    const menuOpen = Number(hierarchy_menu_open ?? 1);

    return {
        tree: normalizedTree,
        hierarchy_menu_open: menuOpen === 0 ? 0 : 1,
    };
}

export function isAntMenuOpen(hierarchy_menu_open) {
    return Number(hierarchy_menu_open) === 1;
}

export function toHierarchyMenuOpen(collapsed) {
    return collapsed ? 0 : 1;
}

export async function fetchAntMenuList() {
    const response = await antMenuApi.getListNameAnts();
    if (response.data.code === SUCCESS) {
        return resolveAntMenuPayload(response.data.data);
    }

    throw response.data.message;
}

export async function updateAntMenuState(hierarchy_menu_open) {
    const response = await antMenuApi.updateMenuState({
        open: Number(hierarchy_menu_open) === 0 ? 0 : 1,
    });

    if (response.data && response.data.code === SUCCESS) {
        return response.data.data;
    }

    throw response.data?.message || "Update menu state failed";
}

export async function renameAntMenuTenant(tenantCode, tenantName) {
    const response = await antMenuApi.renameTenant(tenantCode, {
        tenant_name: tenantName,
    });

    if (response.data && response.data.code === SUCCESS) {
        return response.data.data;
    }

    throw response.data?.message || "Rename tenant failed";
}

export async function exportAntMenuCsv() {
    const response = await antMenuApi.exportHierarchyCsv();

    if (response.data && response.data.code === SUCCESS) {
        return response.data.data;
    }

    if (response.status === SUCCESS) {
        return response.data;
    }

    throw response.data?.message || "Export failed";
}
